import { CorrelationCalculationType, CorrelationResultType, korrelation, korrelationResult } from "./korrelationTypes";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { RootState, AppDispatch } from "../../../app/store";
import { getWithAuth, postJsonWithAuth } from "../../../utils/api";
import { logError } from "../../../utils/utils";
import { openSnackbar } from "../../../features/snackbar/globalSnackbarSlice";
import { errorHandler } from "../../../utils/errorHandling";

const initialState: korrelation
  = {
  korrelationList: [],
  headerList: [],
  loadingKorrelation: false
}

const korrelationSlice = createSlice({
  name: "korrelation",
  initialState,
  reducers:
  {
    setKorrelationList: (state, action: PayloadAction<korrelationResult[][]>) => {
      state.korrelationList = action.payload;
    },
    setHeaderList: (state, action: PayloadAction<string[]>) => {
      state.headerList = action.payload;
    },
    setLoadingKorrelation: (state, action: PayloadAction<boolean>) => {
      state.loadingKorrelation = action.payload;
    },

  }
});

export const selectKorrelationList = (state: RootState): korrelationResult[][] => state.korrelation.korrelationList;
export const selectHeaderList = (state: RootState): string[] => state.korrelation.headerList;
export const selectLoadingKorrelation = (state: RootState): boolean => state.korrelation.loadingKorrelation;

export const {
  setKorrelationList,
  setHeaderList,
  setLoadingKorrelation
} = korrelationSlice.actions;

export const getKorrelation = (id: number, resultType: CorrelationResultType, kenngroesse = 0, messstelle = '') => (dispatch: AppDispatch): void => {
  dispatch(setLoadingKorrelation(true));
  getWithAuth("KORRELATIONGET", {
    id: id,
    resultType: resultType,
    kenngroesse: kenngroesse,
    messstelle: messstelle
  })
    .then((response: Array<Array<korrelationResult>>) => {
      dispatch(setKorrelationList(response));

        const headerList: Array<string> = [];

        response.forEach(rows => {
          rows.forEach(row => {
            headerList.push(row.col)
          })
        })

        headerList.sort((a, b) => a.localeCompare(b))
        const filterdHeaderList: Array<string> = headerList.filter(function (elem, pos) {
          return headerList.indexOf(elem) == pos;
        })

        dispatch(setHeaderList(filterdHeaderList));
    })
    .catch((error) => {
      logError(error);
      errorHandler(error, dispatch);
    }).finally(() => dispatch(setLoadingKorrelation(false)));
}

export const calculateCorrelation = (name: string, start: Date, ende: Date, typ: CorrelationCalculationType, ergebnistyp: CorrelationResultType, messstellen: Array<string>, kenngroessen: Array<string>, koeffMin: number, koeffMax: number) => (dispatch: AppDispatch): void => {
  const body = {
    name: name,
    start: start,
    ende: ende,
    typ: typ,
    ergebnistyp: ergebnistyp,
    messstellen: messstellen,
    kenngroessen: kenngroessen,
    koeffizientMin: ergebnistyp == CorrelationResultType.single ? null : koeffMin,
    koeffizientMax: ergebnistyp == CorrelationResultType.single ? null : koeffMax,
  }
  dispatch(setLoadingKorrelation(true));
  postJsonWithAuth("KORRELATIONCALCULATE", {}, body)
    .then(() => {
      dispatch(openSnackbar({
          message: `Korrelation wurde zur Berechnung angefragt.`,
          severity: "success",
          duration: 6000,
        }));
    })
    .catch((error) => {
      logError(error);
      errorHandler(error, dispatch);
    }).finally(() => dispatch(setLoadingKorrelation(false)));
}

export default korrelationSlice.reducer;